/**
 * Адреса экранов сверки (§5, §6 дополнения о сверке, D264). С 21.10.2026
 * они живут в разделе «Оплаты» (D267) — полный список адресов там же,
 * `payments/paths.ts`:
 *
 * - `/payments/suppliers` — поставщики: долг в системе, по банку и по акту;
 * - `/payments/statements` — загруженные выписки и что в них;
 * - `/payments/suppliers/45?period=month|quarter|year&only=issues` — карточка
 *   поставщика (ссылкой делятся, поэтому фильтры — в адресе);
 * - `/payments/acts/701` — акт сверки со строками и парами.
 */

export { TAB_PATHS } from '../payments/paths';

export function ledgerPath(id: number): string {
  return `/payments/suppliers/${id}`;
}

export function actPath(id: number): string {
  return `/payments/acts/${id}`;
}

/** Период ленты — быстрые кнопки §5: месяц, квартал, с начала года. */
export type LedgerPeriod = 'month' | 'quarter' | 'year';

export const PERIODS: { code: LedgerPeriod; title: string }[] = [
  { code: 'month', title: 'Месяц' },
  { code: 'quarter', title: 'Квартал' },
  { code: 'year', title: 'С начала года' },
];

export function readPeriod(params: URLSearchParams): LedgerPeriod {
  const value = params.get('period');
  return value === 'month' || value === 'quarter' ? value : 'year';
}

/** Сегодня в часовом поясе ресторана — «YYYY-MM-DD». */
export function todayIso(timeZone?: string): string {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone,
    }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

/**
 * Границы периода. «Месяц» и «квартал» — последние 30 и 90 дней, а не
 * календарные: 3 октября «этот месяц» показал бы три дня и пустую ленту.
 */
export function periodRange(period: LedgerPeriod, today: string): { from: string; to: string } {
  if (period === 'year') return { from: `${today.slice(0, 4)}-01-01`, to: today };
  const days = period === 'month' ? 30 : 90;
  const [y, m, d] = today.split('-').map(Number);
  const start = new Date(Date.UTC(y, m - 1, d) - days * 86_400_000);
  return { from: start.toISOString().slice(0, 10), to: today };
}

export function ledgerQuery(period: LedgerPeriod, onlyIssues: boolean): string {
  const params = new URLSearchParams();
  if (period !== 'year') params.set('period', period);
  if (onlyIssues) params.set('only', 'issues');
  const text = params.toString();
  return text ? `?${text}` : '';
}
